export const searchThemesFromCompanies = {
    description: '指定した企業が所属するテーマを確認できます。',
    subtitle1: '企業を選択',
    searchByCompany: '企業名から検索する',
    selectFromFavoriteCompany: 'お気に入り企業から選択',
    subtitle2: '企業が所属するテーマ',
    selected: '選択中',
    searchTableSelect1: 'テーマ名',
    userInputPlaceholder: 'キーワードを入力してください',

    // 企業が保有するテーマ一覧のCSV
    csvColumn1: '企業名',
    csvColumn2: 'テーマ名',
    csvColumn3: 'テーマ内の全出願特許件数',
    csvColumn4: 'テーマ内の全登録特許件数',
    csvColumn6: '指定企業の特許出願件数',
    csvColumn7: '指定企業の登録特許件数',
    csvColumn10: '指定企業の重要特許件数',
    csvColumn11: '指定企業の重要特許保有割合',
    csvColumn8: '指定企業の被引用数',
    csvColumn9: '指定企業の特許出願保有割合',

    // 企業が保有するテーマ一覧
    column1: 'テーマ名',
    column2: 'テーマ内の全出願特許件数',
    column3: 'テーマ内の全登録特許件数',
    column5: '指定企業の特許出願件数',
    column6: '指定企業の登録特許件数',
    column9: '指定企業の重要特許件数',
    column10: '指定企業の重要特許保有割合',
    column7: '指定企業の被引用数',
    column8: '指定企業の特許出願保有割合',

    search: '選択したテーマを分析する'
}
